<div class="page-with-header">
  <!-- List page (design handoff, "Page header pattern"): New module, search
       over the organisations; the modules of the picked organisation open
       beside the list. -->
  <sh-page-header
    [primaryAction]="primaryAction"
    [showSearch]="true"
    [search]="search"
    [resultCount]="resultCount"
    (searchChange)="onSearchChange($event)"
  ></sh-page-header>

  <div class="container-fluid py-3 detail-body">
    <div class="detail-layout">
      <div class="detail-main">
        <div class="surface-card">
          <sh-table
            tableId="seahorse-modules-organisations"
            [columns]="columns"
            [rows]="organisations"
            [paging]="paging"
            [page]="pageIndex"
            [loading]="isLoading"
            rowOpenMode="peek"
            [activeRow]="selectedOrganisation?.id"
            (rowOpen)="selectOrganisation($event)"
            (queryChange)="onQueryChange($event)"
          ></sh-table>
        </div>
      </div>
      <div class="detail-side" *ngIf="selectedOrganisation">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
